module.exports = __webpack_public_path__ + "img/Text-box-red_frame.73b3c803.png";